import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Add from '../../../../../../../assets/images/Souvenir/add .png';
import Unsold from '../../../../../../../assets/images/Souvenir/packages.png';
import pendingMarket from '../../../../../../../assets/images/pending 2.png';
import axios from 'axios';

const MarketPlaceNav = () => {

    
    const [approvedCount, setApprovedCount] = useState('');
    const [pendingCount, setPendingCount] = useState('');
    const [totalOrder, setTotalOrder] = useState('');
    const location = useLocation();

    useEffect(() => {


          axios.get(`/api/admin/marketplace/product-list/approved`).then(res => {

            if(res.data.status === 200)
            {
                setApprovedCount(res.data.approvedCount);
            }
          });
          

          axios.get(`/api/admin/marketplace/product-list/pending`).then(res => {
            if(res.data.status === 200)
            {
              setPendingCount(res.data.pendingCount);
            }
          });
          axios.get(`/api/admin/marketplace/order/product-list`).then(res => {
            if(res.data.status === 200)
            {
              setTotalOrder(res.data.totalOrder);
            }
          });
    
    }, []);


    return (
        <>
            <div className="mb-3 row">

                <div title="Live Now" className="col-md-2 align-items-center justify-content-center Souvenir-bt ">
                    <div className="card meetupCard">
                        <div className="card-body  align-items-center">
                            <center>
                                <tr>
                                    <td className="ad-card-td">
                                        <img src={pendingMarket} width="75px" className="ad-card-img-top" alt="..." />
                                    </td>
                                    <td className="ad-card-td">
                                        <small className=" fw-bold Sigma">{pendingCount}</small>
                                    </td>
                                </tr>
                            </center>
                        </div>
                        {
                            location.pathname === '/superstar-admin/product-list/pending' ?
                            <Link to={{pathname: "/superstar-admin/product-list/pending" }} className=""><button className="card-footer w-100 "
                                data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                                aria-controls="collapseOne" style={{ background: "chartreuse", color: "black" }}> Pending Product
                            </button></Link>
                        :
                            <Link to={{pathname: "/superstar-admin/product-list/pending" }} className=""><button className="card-footer Souvenir-button  w-100 "
                                data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                                aria-controls="collapseOne"> Pending Product
                            </button></Link>
                        }
                    </div>
                </div>

               

                <div title="Live Now" className="col-md-2 align-items-center justify-content-center Souvenir-bt ">
                    <div className="card meetupCard">
                        <div className="card-body  align-items-center">
                            <center>
                                <tr>
                                    <td className="ad-card-td">
                                        <img src={Unsold} className="ad-card-img-top" alt="..." />
                                    </td>
                                    <td className="ad-card-td">
                                        <small className=" fw-bold Unsold">{approvedCount}</small>
                                    </td>
                                </tr>
                            </center>
                        </div>
                        {
                            location.pathname === '/superstar-admin/product-list/approved' ?
                            <Link  to= {{pathname: "/superstar-admin/product-list/approved" }} className="">
                                <button className="card-footer w-100 "
                                data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                                aria-controls="collapseOne" style={{ background: "chartreuse", color: "black" }}> Approved Products List
                            </button></Link>
                        :
                            <Link  to= {{pathname: "/superstar-admin/product-list/approved" }} className="">
                                <button className="card-footer Souvenir-button  w-100 "
                                data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                                aria-controls="collapseOne"> Approved Products List
                            </button></Link>
                        }
                    </div>
                </div>
                <div title="Live Now" className="col-md-2 align-items-center justify-content-center Souvenir-bt ">
                    <div className="card meetupCard">
                        <div className="card-body  align-items-center">
                            <center>
                                <tr>
                                    <td className="ad-card-td">
                                        <img src={pendingMarket} width="75px" className="ad-card-img-top" alt="..." />
                                    </td>
                                    <td className="ad-card-td">
                                        <small className=" fw-bold Sigma">{totalOrder}</small>
                                    </td>
                                </tr>
                            </center>
                        </div>
                        <Link to={{pathname: "/superstar-admin/marketplace-orderlist" }} className=""><button className="card-footer Souvenir-button  w-100 "
                            data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                            aria-controls="collapseOne"> Order List
                        </button></Link>
                    </div>
                </div>

                <div title="Live Now" className="col-md-2 align-items-center justify-content-center Souvenir-bt ">
                    <div className="card meetupCard">
                        <div className="card-body  align-items-center">
                            <center>
                                <tr>
                                    <td className="ad-card-td">
                                        <img src={Add} className="ad-card-img-top" alt="..." />
                                    </td>
                                    <td className="ad-card-td">
                                        <small className=" fw-bold"></small>
                                    </td>
                                </tr>
                            </center>
                        </div>
                        <Link to='/superstar-admin/add-products-marketplace' className=""><button className="card-footer Souvenir-button  w-100 "
                            data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                            aria-controls="collapseOne"> Add products
                        </button></Link>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MarketPlaceNav; 